import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './InfoBanner.module.scss'
import { colors } from '../../../constants/style'
import ButtonWithLinkGroup from '../../button-with-link-group/ButtonWithLinkGroup'
import Container from '../../container/Container'

function InfoBanner({
  bannerTitle,
  bannerSubHeading,
  backgroundColor = colors.blue400,
  handleButtonPress,
  linkText,
  linkPath,
  shadowed,
  buttonText,
  outline,
  linkButtonPath,
  getBambooButton,
  isTargetBlank,
  aboveText,
  mobileLeft,
}) {
  return (
    <section
      className={classNames(styles.section, mobileLeft && styles.mobileLeft)}
      style={{ backgroundColor }}
    >
      <Container fluid>
        <div className={styles.intro}>
          <div className={styles.content}>
            <div className={styles.top}>
              {aboveText && (
                <span className={styles.aboveText}>{aboveText}</span>
              )}
              <h2 className={styles.title}>{bannerTitle}</h2>
            </div>
            <h3 className={styles.subHeading}>{bannerSubHeading}</h3>
          </div>
          {(linkText || buttonText || getBambooButton) && (
            <ButtonWithLinkGroup
              className={styles.buttonsWrapp}
              {...{
                linkText,
                buttonText,
                outline,
                shadowed,
                linkButtonPath,
                linkPath,
                handleButtonPress,
                getBambooButton,
                isTargetBlank,
              }}
            />
          )}
        </div>
      </Container>
    </section>
  )
}

InfoBanner.propTypes = {
  bannerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  buttonText: PropTypes.string,
  linkButtonPath: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  getBambooButton: PropTypes.bool,
  isTargetBlank: PropTypes.bool,
  handleButtonPress: PropTypes.func,
}

export default InfoBanner
